import { useSeo } from "@/lib/seo";
import { PageHeader, Section, CTABanner } from "@/components/blocks";
import { Placeholder } from "@/components/Placeholder";

const STANDARDS = [
  {
    n: "01",
    title: "We listen before we introduce",
    body: "We start with your family — your routine, your children's ages and temperaments, and the kind of support you're genuinely looking for.",
  },
  {
    n: "02",
    title: "We get to know our nannies",
    body: "We take time to understand each nanny's experience, the age groups they've cared for, their training and how they like to work.",
  },
  {
    n: "03",
    title: "We introduce with context",
    body: "Rather than a list of profiles, we introduce nannies we believe suit your household, with the context you need to make your own decision.",
  },
  {
    n: "04",
    title: "We handle information carefully",
    body: "Family and nanny details are kept private to our team. Nanny documents are stored privately and are never listed publicly or indexed by search engines.",
  },
];

export default function OurStandards() {
  useSeo({
    title: "Our Standards — Nanny Poppins UAE",
    description:
      "How Nanny Poppins approaches matching: listening first, understanding nannies, introducing with context, and handling information carefully.",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Our Standards"
        title="Care taken at every step."
        intro="Our standards are about how we work — considered, honest and private — rather than claims we can't stand behind."
      />

      <Section>
        <div className="space-y-px overflow-hidden rounded-2xl border border-[#0B0A08]/10 bg-white">
          {STANDARDS.map((s) => (
            <div
              key={s.n}
              data-testid={`standard-${s.n}`}
              className="grid gap-4 border-b border-[#0B0A08]/8 p-8 last:border-b-0 md:grid-cols-[auto_1fr] md:gap-10 md:p-10"
            >
              <span className="font-serif text-3xl text-[#C6A04A]">{s.n}</span>
              <div>
                <h3 className="font-serif text-xl tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#0B0A08]/70">{s.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-dashed border-[#C6A04A]/50 bg-[#C6A04A]/5 p-8">
          <p className="text-sm leading-relaxed text-[#0B0A08]/75">
            To keep things honest, we don't currently make claims about verification, background checks or
            guaranteed outcomes. Any specific credentials or accreditations will appear here only once
            confirmed.{" "}
            <Placeholder>Accreditation details — to be confirmed</Placeholder>
          </p>
        </div>
      </Section>

      <CTABanner />
    </div>
  );
}
